export default __webpack_public_path__ + "static/adapters-0a262cb448294c590be1168d5bdef768.png";